module.exports = __webpack_public_path__ + "static/media/calendarIcon.580e5f2c.svg";